import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import {PaymentService} from '../../services/payment.service';

@Component({
  selector: 'app-history-credits-dialog',
  templateUrl: './history-credits-dialog.component.html',
  styleUrls: ['./history-credits-dialog.component.css']
})
export class HistoryCreditsDialogComponent implements OnInit {

  public transactions: any;
  page: number;
  total: number;
  max: number;
  loading: boolean;

  constructor(
    public dialogRef: MdDialogRef<HistoryCreditsDialogComponent>,
    public paymentService: PaymentService
  ) {
    this.loading = true;
    this.page = 1;
    this.total = 0;
    this.max = 5;
  }

  ngOnInit() {
    this.searchTransactions();
  }

  searchTransactions (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;

    this.page = page;
    if (page == null) {
      page = 1;
    }
    this.paymentService.getTransaction(page, this.max)
    .subscribe(
    data => {
      this.transactions = data.transaction;
      this.total = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.transactions = undefined;
        this.loading = false;
      } else {
        console.log(error);
        this.transactions = undefined;
        this.loading = false;
      }
    });
  }

  onPageChange(page) {
    this.searchTransactions (page);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/history-credits-dialog/history-credits-dialog.component.ts